jQuery(document).ready(function () {

  return;

  // --- Ancien code (gardé en commentaire pour mémoire) ---
  /*
  jQuery(document).on("change", 'input[custom_id="radio_1"]', function(){
      console.log("yes => " + jQuery(this).attr("custom_id"));
      var curr_radio_id = jQuery(this).attr("custom_id");
      if(curr_radio_id == "radio_1" && jQuery(this).is(':checked')) {
        setTimeout(function() {
          jQuery('label[custom_id="label_2"]').first().find("img").trigger("click");
        }, 2000);
      }
  });
  jQuery(document).on("change", 'input[custom_id="radio_2"]', function(){
      console.log("yes => " + jQuery(this).attr("custom_id"));
      var curr_radio_id = jQuery(this).attr("custom_id");
      if(curr_radio_id == "radio_2" && jQuery(this).is(':checked')) {
        setTimeout(function() {
          if(jQuery('label[custom_id="label_3"]').length > 1) {
            jQuery('label[custom_id="label_3"]').eq(1).find("img").trigger("click");
            jQuery('label[custom_id="label_3"]').eq(0).find("img").trigger("click");
          } else {
            jQuery('label[custom_id="label_3"]').first().find("img").trigger("click");
          }
        }, 2000);
      }
  });
  jQuery(document).on("change", 'input[custom_id="radio_3"]', function(){
    console.log("yes => " + jQuery(this).attr("custom_id"));
  });
  */
});